<script>
import { getApplicationById } from "../services/services";
import html2pdf from "html2pdf.js";
export default {
  name: "Export",
  components: {},
  data() {
    return {
      application: {
        id: 0,
        firstName: "",
        lastName: "",
        netId: "",
        major: "",
        yearInSchool: "",
        gpa: "",
        phoneNumber: "",
        email: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        citizenship: "Yes",
        fellowships: ["", "", ""],
        locationOfInternship: "",
        startDate: "",
        endDate: "",
        year: "",
        courseNumber: "",
        semester: "",
        department: "",
        resume: {},
        letter: {},
        professorSendSeperate: "No",
        researchExperience: "",
        careerAspirations: "",
        uniqueQualifications: "",
        digitalSignature: "",
        professorEmail: "",
      },
    };
  },
  methods: {
    exportToPDF() {
      html2pdf(document.getElementById("content"), {
        margin: [15, 15],
        filename: "pdfFileName.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, letterRendering: true },
        jsPDF: { unit: "pt", format: "letter", orientation: "portrait" },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      });
    },
  },
  mounted() {
    const id = this.$route.query.id;
    if (!!id) {
      this.id = id;

      getApplicationById(id).then((data) => {
        const app = { ...data };
        app.citizenship = data.usCitizen ? "Yes" : "No";
        app.fellowships = data.sitesApplying.split(",");
        app.startDate = new Date(app.startDate).toLocaleDateString();
        app.endDate = new Date(app.endDate).toLocaleDateString();
        this.application = app;
      });
    }
  },
};
</script>

<template>
  <div style="padding-left: 2vw; padding-right: 2vw;">
    <div id="content">
      <v-layout column>
        <h1 style="padding-bottom: 1vh">Personal Information</h1>
        <v-layout row>
          <b style="padding-left: 1vw">First Name:</b>
          <p style="padding-left: 1vw">{{ application.firstName }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Last Name:</b>
          <p style="padding-left: 1vw">{{ application.lastName }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Net ID:</b>
          <p style="padding-left: 1vw">{{ application.netId }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Year in School:</b>
          <p style="padding-left: 1vw">{{ application.yearInSchool }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Major:</b>
          <p style="padding-left: 1vw">{{ application.major }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">GPA:</b>
          <p style="padding-left: 1vw">{{ application.gpa }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Phone Number:</b>
          <p style="padding-left: 1vw">{{ application.phoneNumber }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Email:</b>
          <p style="padding-left: 1vw">{{ application.email }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Mailing Address:</b>
          <p style="padding-left: 1vw">{{ application.address }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">City:</b>
          <p style="padding-left: 1vw">{{ application.city }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">State:</b>
          <p style="padding-left: 1vw">{{ application.state }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">ZIP Code:</b>
          <p style="padding-left: 1vw">{{ application.zip }}</p>
        </v-layout>
        <h1 style="padding-top: 2vh; padding-bottom: 1vh">
          Academic Information
        </h1>
        <v-layout row>
          <b style="padding-left: 1vw">United States Citizen?</b>
          <p style="padding-left: 1vw">{{ application.citizenship }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Fellowship 1:</b>
          <p style="padding-left: 1vw">{{ application.fellowships[0] }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Fellowship 2:</b>
          <p style="padding-left: 1vw">{{ application.fellowships[1] }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Fellowship 3:</b>
          <p style="padding-left: 1vw">{{ application.fellowships[2] }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Start Date:</b>
          <p style="padding-left: 1vw">{{ application.startDate }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">End Date:</b>
          <p style="padding-left: 1vw">{{ application.endDate }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Year:</b>
          <p style="padding-left: 1vw">{{ application.year }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Course Number:</b>
          <p style="padding-left: 1vw">{{ application.courseNumber }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Semester:</b>
          <p style="padding-left: 1vw">{{ application.semester }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Research Experience:</b>
          <p style="padding-left: 1vw">{{ application.researchExperience }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">School Career Aspirations:</b>
          <p style="padding-left: 1vw">{{ application.careerAspirations }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Unique Qualifications:</b>
          <p style="padding-left: 1vw">
            {{ application.uniqueQualifications }}
          </p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw"
            >Current or anticipated scholarships, assistantships, fellowships,
            grants, or any other sources of funding you will have during this
            fellowship:</b
          >
          <p style="padding-left: 1vw">{{ application.otherFunding }}</p>
        </v-layout>
        <v-layout row>
          <b style="padding-left: 1vw">Digital Signature:</b>
          <p style="padding-left: 1vw">{{ application.digitalSignature }}</p>
        </v-layout>
      </v-layout>
    </div>
  </div>
</template>

<style>
</style>